import axios from 'axios';
import config from '../utils/config';

const getUserInfo = async (email) => {
  const accessToken = await window.localStorage.getItem('access_token');
  const response = await axios.request({
    url: `${config.serverBasePath}/api/v2/users/?email=${email}`,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      withCredentials: true,
      Authorization: `Bearer ${accessToken}`,
      'Access-Control-Allow-Origin': '*'
    },
  });
  return response.data;
};

export default getUserInfo;
